<template>
  <div id="mysharefileTable">
    <el-upload ref="gentlyUpload" :action="actionUrl" :headers="Token" :show-file-list="false" :accept="accept"
      :on-error="handleError" :before-upload="handleBeforeUpload" :on-success="handleAvatarSuccess"
      :file-list="fileList" style="height: 0;">
      <el-button id="gentlyBtn" size="small" style="display:none;">
        轻量化
      </el-button>
    </el-upload>
    <el-table ref="multipleTable" v-loading="shareLoading" :data="shareList" tooltip-effect="dark" empty-text border height="100%" class="tableCol">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size:16px;color:#000;">
          暂无数据
        </p>
      </template>
      <el-table-column v-if="show" ref="fileNameSort" :key="13" show-overflow-tooltip align="left" label="文件名称" prop="title">
        <template slot-scope="{ row }">
          <div style="display:flex;align-items: center" class="colCheck">
            <img :src="className(row)" style="flex-shrink:0;margin:0 5px" />
            <div style="cursor: pointer" @click="clickTitle(row)">
              <span :style="row.isExpired===1?'color:var(--info-color)':'color:var(--key-color)'">{{ row.title }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="show" ref="fileNameSort" :key="12" show-overflow-tooltip align="center" label="共享链接"
        width="220">
        <template #default="{row}">
          <template v-if="row.isExpired !== 1">
            <el-popconfirm :hide-icon="true" :width="220" :title="row.fileUrl" trigger="hover"
              confirm-button-text="复制" popper-class="copyUrPopper" @cancel="falseCopy" @confirm="copyUrl(row.fileUrl)">
              <template #reference>
                <el-button size="small"> 查看链接 </el-button>
              </template>
            </el-popconfirm>
            <el-button size="small" style="margin-left:10px" @click="delShare(row)"> 取消分享 </el-button>
          </template>
          <el-button v-else size="small" class="deleteShareStyle" type="danger" plain @click="deleteShare(row)">删除</el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="show" :key="2" align="center" label="访问密码" prop="pwd" width="120" show-overflow-tooltip>
        <template #default="scope">
          <el-popconfirm :hide-icon="true" :width="220" :title="scope.row.pwd" confirm-button-text="复制" trigger="hover"
            @cancel="falseCopy" @confirm="copyPwd(scope.row.pwd)">
            <template #reference>
              <el-button v-if="scope.row.pwd !== null" size="small">
                {{ scope.row.pwd }}
              </el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
      <el-table-column v-if="show" :key="3" :formatter="endTimeChange" align="center" label="失效时间" prop="endDate"
        width="240" show-overflow-tooltip>
        <template #default="{ row }">
          <span style="width:80%;" :style="row.isExpired===1?'color:var(--info-color)':'color:var(--key-color)'">{{ endTimeChange(row) }}</span>
          <img v-if="row.isExpired===1" :src="expired" alt="">
        </template>
      </el-table-column>
      <el-table-column v-if="show" :key="4" :formatter="isDownload" align="center" label="是否允许下载" prop="isDownload"
        width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column v-if="!show" ref="fileNameSort" :key="17" show-overflow-tooltip align="left" label="文件名称"
        prop="folderName">
        <template slot-scope="{ row }">
          <div style="display:flex;align-items: center" class="colCheck">
            <!-- 轻量化图标 -->
            <fileLightFlag :row="row" class="lightShare" @updateLight="updateLight" />
            <!-- 文件的图标 -->
            <img v-if="checkFileType(row)" :src="className(row)" style="flex-shrink:0;margin:0 5px;position: absolute;left:26px" />
            <img v-else :src="className(row)" style="flex-shrink:0;margin:0 5px;" />
            <div v-if="checkFileType(row)" :style="{ cursor: cacheListContent.createFolder.folderId === 'recycle' ? '' : 'pointer', }"
              style="position: absolute;left:55px" @click.stop="clickFolderFile(row, $event)">
              <span style="width:80%;">{{ row.folderName }}</span>
            </div>
            <div v-else :style="{ cursor: cacheListContent.createFolder.folderId === 'recycle' ? '' : 'pointer', }" @click.stop="clickFolderFile(row, $event)">
              <span style="width:80%;">{{ row.folderName }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="!show" :key="15" align="center" label="操作" width="260">
        <template slot-scope="scope">
          <div class="more">
            <i class="el el-icon-download rowIcon" title="下载" @click.stop="downloadFile(scope.row)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="!show" :key="11" :formatter="formatterFileSize" prop="fileSize" align="center" label="文件大小"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column :key="5" align="center" prop="operDate" label="分享时间" width="200" show-overflow-tooltip>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { filePreviewV1, tableRowIcon, common2D3DFileType } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import requestFile from "@/CommonDP/service/webShare-service";
import { downloadUrltoken, gentlyUrl, downloadFile } from "@/CommonDP/utils";
import { getToken } from "@/CommonDP/utils";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";

export default {
  components: { fileLightFlag },
  data() {
    return {
      rechristenCommitName: "",
      isShowRechristen: [],
      cacheListContent: {
        createFolder: {}
      },
      Token: {
        Token: getToken()
      },
      actionUrl: "",
      accept: "",
      qinglianghuaList: [],
      fileList: [],
      visible: false,
      shareList: [],
      show: true,
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      expired: require("@/CommonDP/assets/share/expired.png"),
      shareLoading: false,
      prjId: ''
    };
  },
  computed: {
    ...mapState({
      navArr: state => state.perFile.navArrDan,
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo
    })
  },
  created() {
    this.querlist2();
  },
  methods: {
    async querlist2() {
      this.show = true;
      this.shareLoading = true;
      const pageNum = 1;
      const pageSize = 999;
      const isOut = 1;
      const enterpriseId = this.enterpriseId;
      this.shareList = [];
      try {
        const result = await requestFile.queryGetShare(pageSize, pageNum, isOut, enterpriseId);
        this.shareList = result.data;
        this.shareLoading = false;
      } catch (e) {
        this.shareLoading = false;
        this.$store.dispatch("perFileUpdateMessageObj", { isShow: true, message: e.message || "加载失败" });
      }
    },
    falseCopy() {
      this.$message.warning("取消复制！");
      this.visible = false;
    },
    copyPwd(val) {
      this.$copyText(val).then(res => {
        this.isCopy = true;
        this.$message.success("密码复制成功！");
      });
    },
    copyUrl(val) {
      this.$copyText(val).then(res => {
        this.isCopy = true;
        this.$message.success("链接复制成功！");
      });
    },

    delShare(val) {
      this.$confirm("取消分享之后，之前分享的链接将会失效，是否确认取消？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        const param = [];
        param.push(val.id);
        requestFile.cancelShare(param).then(res => {
          if (res.result == "0") {
            this.$store.dispatch("perFileUpdateNodeList");
            this.querlist2();
            this.$message({
              duration: 1000,
              message: "取消分享成功",
              type: "success",
              showClose: true
            });
          } else {
            this.$message.warning(res.message);
          }
        });
      });
    },
    deleteShare(val) {
      this.$confirm("删除分享,是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const param = [];
          param.push(val.id);
          requestFile.personalDocDeleteShare(param)
            .then(res => {
              if (res.result == "0") {
                this.$store.dispatch("perFileUpdateNodeList");
                this.querlist2();
                this.$message({ duration: 1000, message: "删除分享成功", type: "success", showClose: true });
              } else {
                this.$message.warning(res.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    // 点击文件名称
    async clickFolderFile(row, event) {
      if (row.isFile === 1 || row.isFolder === 1) { // 如果是文件夹 就直接下一级
        // this.loadBoolean= true
        this.queryDocShareList(row);
      } else {
        this.viewFile(row, event); // 文件预览
      }
    },

    async viewFile(row, event) {
      this.onLineView(row);
    },

    async onLineView(row) {
      const { status, folderId: fileId, fileVersion: versionId, parentId, fileType } = row;
      const data = {
        status, fileId, versionId, parentId, fileType
      };
      filePreviewV1(data, this.list);
    },
    async queryDocShareList(row) {
      const params = {
        folderId: row.folderId,
        prjId: this.prjId,
        isRead: 1,
        priviAll: "1",
        noRightClickMenu: true,
        versionId: ""
      };
      const res = await docService.queryTree(params);
      this.shareList = res.data.map(item => {
        const { childFolder = 0 } = item;
        return {
          ...item,
          leaf: childFolder === 0
        };
      }) || [];
    },

    async downloadFile(row) {
      const prjId = "MyDoc";
      const userInfo = this.userInfo;
      const { userId, token } = userInfo;
      if (row.isFile !== 1) {
        const fileId = row.folderId;
        const version = row.fileVersion;
        const downzipurl = downloadUrltoken(prjId, fileId, version);
        downloadFile(downzipurl);
      } else {
        var params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        console.log(params);
        docService.downloadfolder(params).then(response => {
          const fileName = row.folderName + ".zip";
          if ("msSaveOrOpenBlob" in navigator) {
            // 兼容ie
            window.navigator.msSaveOrOpenBlob(response, fileName);
            return;
          } else {
            const link = document.createElement("a");
            const blob = response;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },

    async rechristen({ $index, row }) {
      this.isShowRechristen = [];
      if (row.isFile === 1) {
        this.rechristenCommitName = row.folderName;
      } else {
        const typeIndex = row.folderName.lastIndexOf(".");
        const newName = row.folderName.substring(0, typeIndex);
        this.rechristenCommitName = newName;
      }
      this.isShowRechristen[$index] = true;
      this.$set(this.isShowRechristen, $index, true);
      this.$nextTick(() => {
        const ref = "input" + row.folderId;
        this.$refs[ref].focus();
      });
    },

    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.folderId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    checkFileType(row) {
      return common2D3DFileType(row);
    },

    handleBeforeUpload(file) {
      const lastObj = this.qinglianghuaList[this.qinglianghuaList.length - 1];
      const uploadFileName = this._splitFileName(file.name);
      const rvtFileName = this._splitFileName(lastObj.folderName);
      if (uploadFileName !== rvtFileName) {
        this.$message({
          message: `请选择和${lastObj.fileType === 7 ? "rvt" : "skp"}文件匹配的轻量化文件`,
          type: "warning",
          duration: 2000,
          showClose: true
        });
        return false;
      }
      lastObj.status = "1";
      this.$message.success("操作成功,正在轻量化");
    },

    _splitFileName(text) {
      const pattern = /\.{1}[a-zA-Z]{1,}$/;
      if (pattern.exec(text) !== null) {
        return text.slice(0, pattern.exec(text).index);
      } else {
        return text;
      }
    },

    _splitFileType(text) {
      const lastIndex = text.lastIndexOf(".");
      return text.substring(lastIndex + 1);
    },

    handleAvatarSuccess(response, file, fileList) {
      let status;
      let message;
      let type;
      if (response.data.code === 0) {
        status = "2";
        message = "文件轻量化成功";
        type = "success";
      } else {
        status = "";
        message = response.data.msg || "轻量化失败,请重新轻量化";
        type = "warning";
      }
      const rvtId = response.data.rvtId;
      const obj = this.qinglianghuaList.find(item => item.folderId === rvtId);
      obj.status = status;
      this.$message({
        message: message,
        type: type,
        duration: 2000,
        showClose: true
      });
      const index = this.qinglianghuaList.findIndex(item => item.folderId === rvtId);
      if (index > -1) {
        this.qinglianghuaList.splice(index, 1);
      }
    },

    handleError() {
      this.$message({
        message: "文件轻量化失败,请重新轻量化",
        type: "warning",
        duration: 2000,
        showClose: true
      });
    },

    async gently(scope) {
      const { row } = scope;
      this.qinglianghuaList.push(row);
      if (row.fileType === 7) {
        this.accept = ".bimex";
      } else {
        this.accept = ".bimex,.usdp";
      }
      const prjId = this.enterpriseId;
      const rvtId = row.folderId;
      const rvtVersion = row.fileVersion;
      this.actionUrl = gentlyUrl(rvtId, prjId, rvtVersion);
      this.$nextTick(() => {
        const gentlyBtn = document.getElementById("gentlyBtn");
        if (gentlyBtn) {
          gentlyBtn.click();
        }
      });
    },

    showProperty(row) {
      this.$store.dispatch("perFileIsShowProperty", row);
    },

    async deleteRow(row) {
      const folderId = row.folderId;
      try {
        this.$confirm("确定删除吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: true,
              message: "删除中..."
            });
            const result = await docService.queryDeleteFile([folderId]);
            if (result.result === "0") {
              this.querlist2();
              this.$store.dispatch("perFileUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.$message({ type: "success", message: "删除成功" });
            }
          })
          .catch(() => {});
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: false,
          message: ""
        });
      }
    },

    isFinalGently(row) {
      return row.fileType === 7 || row.fileType === 18 || row.fileType === 19;
    },

    formatterFileSize(row, column) {
      if (row.fileSize === "0B") {
        return "-";
      } else {
        return row.fileSize;
      }
    },
    isDownload(row, colum) {
      if (row.isDownload === 1) {
        return "是";
      } else {
        return "否";
      }
    },
    endTimeChange(row, colum) {
      if (row.endDate == "2099-12-31 23:59:59") {
        return "永久";
      } else {
        return row.endDate;
      }
    },

    className(row) {
      return tableRowIcon(row);
    },
    parent2() {
      this.querlist2();
    },
    clickTitle(row) {
      if (row.isExpired === 1) {
        this.$message.warning("已取消分享");
        return;
      }
      this.show = false;
      this.prjId = row.prjId;
      this.shareList = row.list;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#mysharefileTable {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  padding: 0 var(--big-space) var(--middle-space);
  .lightShare{
    position absolute
    left 15px
  }
  /deep/ .el-table {
    .el-table__body-wrapper {
      .rowIcon {
        cursor: pointer;
        color: #A1C5E7;
        font-size: 16px;
      }
    }

    .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(255, 255, 255);
      border-radius: 2px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #C4C6CC;
    }
  }
}
</style>
<style lang="scss">
.copyUrPopper{
  .el-popconfirm__main{
    margin: 5px 0px;
  }
}
</style>
